import { render, staticRenderFns } from "./RequestReturnHead.vue?vue&type=template&id=5efa4150"
import script from "./RequestReturnHead.vue?vue&type=script&lang=js"
export * from "./RequestReturnHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports